var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/ModelRepo/ModelRepoFolder.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { createPredicate } from '../createPredicate';
import { Id } from '../Id';
import { ApiDomain } from '../domain';
import { BimFile } from './BimFile';
export var ModelRepoFolder;

(function (_ModelRepoFolder) {
  var domain = ApiDomain.domain('ModelRepoFolder', {
    name: "domain",
    sid: "-hxvkib"
  });
  var type = 'ModelRepositoryFolder';
  var io = _ModelRepoFolder.io = t.type({
    type: t.literal('ModelRepositoryFolder'),
    id: Id,
    name: t.string,
    total: t.number
  }, 'ModelRepositoryFolder');
  var is = _ModelRepoFolder.is = createPredicate(type);
  var Populated;

  (function (_Populated) {
    var type = _Populated.type = 'ModelRepositoryFolderPopulated';
    var io = _Populated.io = t.type({
      type: t.literal('ModelRepositoryFolderPopulated'),
      id: Id,
      name: t.string,
      total: t.number,
      offset: t.number,
      children: t.array(t.union([BimFile.io, ModelRepoFolder.io]))
    }, 'ModelRepositoryFolderPopulated');
    var fetch = _Populated.fetch = ApiCallService.create({
      name: 'fetch',
      parentDomain: domain,
      result: io,
      getKey: ['folderId']
    });
    var fetchSilent = _Populated.fetchSilent = ApiCallService.create({
      name: 'fetchSilent',
      parentDomain: domain,
      result: io,
      getKey: ['folderId']
    });
  })(Populated || (Populated = _ModelRepoFolder.Populated || (_ModelRepoFolder.Populated = {})));
})(ModelRepoFolder || (ModelRepoFolder = {}));